import React, { FC, useEffect } from 'react'
import { Stack, Typography } from '@mui/material'
import { object, string } from 'yup'

import { B2CRegistryConfirmForm } from '@/@types/b2c.types.ts'
import { VerifyCodeField } from '@/components'
import { Form, FormSchema, FormSchemaMessages, SubmitButton, SubmitErrorMessage } from '@/components/form'
import { B2C_ENDPOINTS, useMutateB2cRegistryConfirm, useMutateB2CResendCode } from '@/services'

const B2C_TRANSFER_CONFIRM_FORM_NAME = 'newB2CTransferConfirm'

const verifyB2CFormSchema = object<FormSchema<B2CRegistryConfirmForm>>({
  code: string().required(FormSchemaMessages.required),
})

type B2CConfirmDialogProps = {
  registryId?: number
  onSuccess(): void
}

export const B2CConfirmDialog: FC<B2CConfirmDialogProps> = ({ onSuccess, registryId }): React.ReactElement => {
  const handleB2CCode = useMutateB2CResendCode()
  const { isError, error, ...handleConfirm } = useMutateB2cRegistryConfirm()

  useEffect(() => {
    handleB2CCode.mutate()
  }, [])

  useEffect(() => {
    switch (handleConfirm.status) {
      case 'success': {
        onSuccess()
        handleConfirm.reset()
        break
      }
      default:
        break
    }
  }, [handleConfirm.status])

  const handleSubmit = async (form: B2CRegistryConfirmForm) => {
    if (!registryId) return
    try {
      await handleConfirm.mutateAsync({ ...form, id: registryId })
      onSuccess()
    } catch (e) {
      console.log()
    }
  }

  return (
    <Form name={B2C_TRANSFER_CONFIRM_FORM_NAME} validationSchema={verifyB2CFormSchema} onSubmit={handleSubmit}>
      <Stack gap={2}>
        <Stack gap={2}>
          {handleB2CCode.data?.data?.message && <Typography>{handleB2CCode.data?.data.message}</Typography>}
          <VerifyCodeField login={''} apiUrl={B2C_ENDPOINTS.resendCode} codeLifespanMin={1} />
        </Stack>
        <SubmitErrorMessage
          message={
            isError ? error?.response?.data?.errorDetails : 'Произошла непредвиденная ошибка, попробуйте ещё раз'
          }
          isError={isError}
        />
        <SubmitButton form={B2C_TRANSFER_CONFIRM_FORM_NAME}>Подтвердить</SubmitButton>
      </Stack>
    </Form>
  )
}
